import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dismiss"]

  setHighlight(event) {
    event.preventDefault()
    const target = event.detail.element || event.target
    const container = target && target.closest(".highlight-container") || target.querySelector(".highlight-container")
    container && this.#displayHighlight(target, container)
  }

  highlightFromAnchor(event) {
    event.preventDefault()
    const target = event.currentTarget
    const container = target && target.closest(".highlight-container")
    container && this.#displayHighlight(target, container)
    this.#copyToClipboard(target)
  }

  highlightInDoc(event) {
    event.preventDefault()
    const property = event.currentTarget
    const propertyId = property.dataset.anchor

    const docProperty = this.element.querySelector(`.explorer-doc #${propertyId}`)

    if (docProperty) {
      this.dispatch("goTo", { target: document, detail: { element: docProperty }, prefix: false })
      this.#displayHighlight(docProperty, docProperty.closest(".highlight-container"), {block: "center"})
    }
  }

  dismiss(event) {
    // Only real user clicks dismiss: the go-to controller opens oneOf
    // tabs with a synthetic click, which would wipe the highlight the
    // moment a shared URL lands inside one. Non-click triggers (the
    // explorer's toggle:hide) stay untouched.
    if (event.type === "click" && !event.isTrusted) {
      return
    }

    const outsideAnchor = !event.target.closest(".anchor-link") && !event.target.closest("dialog")

    if (outsideAnchor || event.target.closest(".dismiss-highlight")) {
      const container = document.querySelector(".shared")
      this.#removeHighlight(container)
    }
  }

  #displayHighlight(target, container) {
    this.#removeHighlight(this.element.querySelector(".shared"))
    container.classList.add("shared")
    this.#appendDismissButton(container)
  }

  // The button goes inside the container's first .anchor-link so it
  // shares the anchor icon's containing block and lands exactly where
  // the icon shows, whatever the context.
  #appendDismissButton(container) {
    if (!this.hasDismissTarget) {
      return
    }

    if (!container.querySelector(".dismiss-highlight")) {
      const anchor = container.querySelector(".anchor-link") || container
      anchor.appendChild(document.importNode(this.dismissTarget.content, true))
    }
  }

  #removeHighlight(container) {
    if (!container) return

    container.classList.remove("shared")
    container.querySelector(".dismiss-highlight")?.remove()
  }

  #copyToClipboard(link) {
    const href = link.getAttribute("href")
    history.pushState({}, "", href)
    navigator.clipboard.writeText(window.location)
    link.classList.add("active")

    setTimeout(() => {
      link.classList.remove("active")
    }, 2000)
  }
}
